import React, { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import { ToastsStyles } from './ToastsProvider.styles';

interface ToastsProviderProps {}

const ToastsProvider: FC<ToastsProviderProps> = () => (
  <>
    <ToastsStyles />
    <ToastContainer
      toastClassName="app-toast"
      hideProgressBar={true}
      icon={false}
      newestOnTop
      autoClose={3000}
      closeButton={false}
    />
  </>
);

export default ToastsProvider;
